<template>
  <v-layout>
    <navbar title="ARES - Messages" type="messages" :home="true" @actionClick="actionClick" />  
    <v-navigation-drawer permanent style="padding-top:64px">
      <v-list dense nav>
        <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            Messages
          </v-list-item-title>
          
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

        <v-list-item v-for="item in items" :key="item.title" link @click="getMessages(item.conv_nr)">
          <v-badge
            bordered
            color="success"
            overlap
            dot
          >
            <v-avatar size="34">
              <v-img :src="item.from_image"></v-img>
            </v-avatar>
          </v-badge>       
            <channelAvatar :conversationtype="item.type" />
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid style="max-width:600px">
        <v-row cols="12">
          <v-col cols="12" v-if="conversation">
            <v-avatar size="40">
              <v-img :src="conversation.from_image"></v-img>
            </v-avatar>  
            {{ conversation.from_name }}

            {{ conversation.type }}
            started at: 
            {{ conversation.time_stamp }}
            
            <v-divider></v-divider>
          </v-col>
        </v-row>
        
        <v-row class="space-around d-flex flex-column">
                <v-card v-for="message in messages" :key="message.nr" flat>              
                <v-list-item
                    :key="message.nr"
                    v-if="message.from != 'VFY'"
                    class=""
                  >
                    <v-list-item-avatar class="align-self-start mr-1">                     
                      <v-avatar size="40">
                        <v-img :src="message.from_image"></v-img>
                      </v-avatar>                     
                    </v-list-item-avatar>
                    <v-list-item-content class="received-message">
                      <v-card color="#F5F5F5" class="flex-none" flat>                        
                        <v-card-text class="black--text pa-2 d-flex flex-column">
                          <span class="text-caption">{{message.from_name}} <v-btn outlined x-small icon color="black" @click="setReaction(message.nr)" ><v-icon>mdi-arrow-right-top</v-icon></v-btn>  </span>                                                 
                          
                          <span v-if="message.reaction_to" class="align-self-start text-subtitle-2">
                            <v-list-item-content class="sent-reaction">
                              <v-card color="#E8EBFA" class="flex-none" flat>                        
                                <v-card-text class="black--text pa-2 d-flex flex-column">
                                  <span class="text-caption">{{messages[message.reaction_to - 1].body}} </span>
                                </v-card-text>
                              </v-card>
                            </v-list-item-content>

                          </span>
                          <span class="align-self-start text-subtitle-1">
                            {{ message.body }}
                          </span>
                          <span class="text-caption font-italic align-self-end">{{
                            message.time_stamp
                          }}</span> 
                        </v-card-text>
                      </v-card>                   
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-else>
                    <v-list-item-content class="sent-message justify-end">
                      <v-card color="#E8EBFA" class="flex-none" flat>
                        <v-card-text class="black--text pa-2 d-flex flex-column">   
                           <span class="text-caption  align-self-end">
                              <!-- <v-btn outlined x-small icon color="black"><v-icon>mdi-arrow-left-top</v-icon></v-btn> -->  {{message.from_name}} 
                           </span>                                                                                                                         
                           <span v-if="message.reaction_to" class="align-self-start text-subtitle-2">
                            <v-list-item-content class="received-reaction">
                              <v-card color="#F5F5F5" class="flex-none" flat>                        
                                <v-card-text class="black--text pa-2 d-flex flex-column">
                                  <span class="text-caption">{{messages[message.reaction_to - 1].body}} </span>
                                </v-card-text>
                              </v-card>
                            </v-list-item-content>

                          </span>
                           <span class="text-subtitle-1 chat-message">{{ message.body }}</span>
                          <span class="text-caption font-italic align-self-start">{{
                            message.time_stamp
                          }}
                          <img :src="message.image" /> 
                          </span> 
                        </v-card-text>
                      </v-card>
                    </v-list-item-content>
                    <v-list-item-avatar class="align-self-start ml-2">
                      <v-img :src="message.from_image"></v-img>                      
                    </v-list-item-avatar>                    
                </v-list-item> 
              </v-card>
            </v-row>
            <v-row v-if="conversation">
              <span v-if="messageForm.reaction_to !== 0" class="align-self-start text-subtitle-2">
                <v-list-item-content class="received-reaction">
                  <v-card color="#F5F5F5" class="flex-none" flat>                        
                    <v-card-text class="black--text pa-2 d-flex flex-column">
                      <span class="text-caption  align-self-end">
                        Reaction to {{messages[messageForm.reaction_to - 1].from_name}}  : 
                      </span>   
                      <span class="text-caption">{{messages[messageForm.reaction_to - 1].body}}  <v-btn outlined x-small icon color="black" @click="messageForm.reaction_to = 0" ><v-icon>mdi-trash-can-outline</v-icon></v-btn></span>
                    </v-card-text>
                  </v-card>
                </v-list-item-content>
              </span>
              <v-card-text class="flex-shrink-1">
                      <v-text-field
                      v-model="messageForm.body"
                      label="type a message"
                      type="text"
                      no-details
                      outlined
                      append-outer-icon="mdi-send"
                      @keyup.enter="addMessage()"
                      @click:append-outer="addMessage()"
                      
                    />
                  </v-card-text>
            </v-row>
        </v-container>
    </v-main>

    <v-navigation-drawer
      permanent
      right
      style="padding-top:64px"
       v-if="conversation"
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-img :src="conversation.from_image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ conversation.from_name }}</v-list-item-title>
            <v-list-item-subtitle>{{ conversation.type }}<br>
            {{ conversation.time_stamp }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      
      <v-list dense>
        <v-list-item
          v-for="conn in connected_conversations"
          :key="conn.from"
        >
          
          <v-list-item-content>
            <v-list-item-title>
              <v-btn v-if="conversation.conv_nr === conn.from" link @click="getMessages(conn.to)">origin message</v-btn>
              <v-btn v-if="conversation.conv_nr === conn.to" link @click="getMessages(conn.from)">followup message</v-btn><br>
              <v-btn link @click="createFollowupConversation(conversation.conv_nr)">Create followup conversation</v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>



  </v-layout>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import channelAvatar from '@/views/syst/messages/channelAvatar.vue';
    export default {        
        components: {
            navbar,
            channelAvatar,
        },
        props: {
        },
        data() {
            return {
                title: "",
                loading: true,
                messages: [],
                connected_conversations: null,
                conversation: null,
                items: [
                { title: 'Conversation 1', icon: 'mdi-chat' , conv_nr: 1 },
                { title: 'Conversation 2', icon: 'mdi-chat' , conv_nr: 2 },
                ],
                messageForm: {
                  body: "",
                  color:"deep-purple lighten-1",
                  from:"VFY",
                  from_image:"https://icons.iconarchive.com/icons/iconarchive/robot-avatar/256/Cyan-1-Robot-Avatar-icon.png",
                  from_name:"VFY AI Bot",
                  image:"",
                  nr: null,
                  reaction_to: 0,
                  time:"10:01",
                  time_stamp:null,
                },
            }
        },
        mounted() {
          this.getConversations()
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {

            },           
            getMessages(conv_nr) {
                this.conversation = this.items.find((obj) => obj.conv_nr === conv_nr);
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/messages/getMessages.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMessages",
                        conv_nr: conv_nr
                    },
                }).then(res => {
                    console.log(res);
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.messages = res.data.messages;
                        this.connected_conversations = res.data.connected_conversations;
                        this.loading = false;
                    }
                });
            },
            getConversations() {
              this.loading = true;
              this.$axios.post("ares/json/ares/syst/messages/getConversations.p", {
                  header: {
                      token: this.$session.get("ARES"),
                      clientSessionId: this.$session.id(),
                      request: "getConversations"
                  },
              }).then(res => {
                  console.log(res);
                  if (res.data.error) {
                      console.log(res.data.error);
                  } else {
                      this.items = res.data.conversations;
                      this.loading = false;
                  }
              });
            },
            getTimestamp() {
              const event = new Date()
              return event.toISOString()
            },
            updateTimestamp() {
              this.messageForm.time_stamp = this.getTimestamp()
            },
            getNextMessageNr() {
              let nextMssgNr;
              if(this.messages !== undefined){
                nextMssgNr = Math.max.apply(Math, this.messages.map(function(m) { return m.nr; })) + 1;
              } else {
                nextMssgNr = 1;
              }
              return nextMssgNr;
            },
            updateNextMessageNr() {
              this.messageForm.nr = this.getNextMessageNr()
            },
            setReaction(nr) {
              this.messageForm.reaction_to = nr
            },
            addMessage() {
              this.updateNextMessageNr();
              this.updateTimestamp();
              let messageFormCopy = JSON.parse(JSON.stringify(this.messageForm));
              if (this.messages === undefined) { this.messages = [] }
              this.messages.push(messageFormCopy)
              this.messageForm.reaction_to = 0
              this.messageForm.body = ""
            },
            getNextConvNr() {
              return Math.max.apply(Math, this.items.map(function(m) { return m.conv_nr; })) + 1
            },
            createFollowupConversation(nr) {
              let connectedconv;
              let followupconv;
              followupconv = {
                conv_nr: this.getNextConvNr(),
                from:"eign",
                from_image:"https://pbs.twimg.com/profile_images/1798774546/VluggeJapie_400x400.jpg",
                from_name:"Vlugge Japie",
                icon:"mdi-chat",
                origin:"vfy",
                time_stamp:this.getTimestamp(),
                title:"Vlugge Japie",
                to:"VFY",
                to_image:"https://icons.iconarchive.com/icons/iconarchive/robot-avatar/256/Cyan-1-Robot-Avatar-icon.png",
                to_name:"VFY AI Bot",
                type:"chat",
              }
              connectedconv = {
                from: nr,
                to: followupconv.conv_nr
              }
              this.items.push(followupconv)
              this.connected_conversations.push(connectedconv)
            }
        },
    }
</script>

<style scoped>
.chat-message {
  display: unset !important;
  white-space: break-spaces;
}
.chat-screen {
  max-height: 320px;
  overflow-y: auto;
}
.flex-none {
  flex: unset;
}
/*
.received-message::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: 54px;  
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #86BB71 transparent transparent transparent;
}

.sent-message::after {
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    left: auto;    
    right: 54px;
    top: 12px;
    bottom: auto;
    border: 12px solid;
    border-color: #94C2ED transparent transparent transparent;
}
.sent-reaction::after {
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    left: auto;    
    right: 0px;
    top: 41px;
    bottom: auto;
    border: 12px solid;
    border-color: #94C2ED transparent transparent transparent;
}
.received-reaction::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: 0px;  
  right: auto;
  top: 41px;
  bottom: auto;
  border: 12px solid;
  border-color: #86BB71 transparent transparent transparent;
}
*/

</style>